import React from 'react';
import ErrorPage from '@containers/ErrorPage';
import { withRouter } from 'react-router';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: { message: '', stack: '' },
    info: { componentStack: '' },
  };

  constructor(props) {
    super(props);
  }

  static getDerivedStateFromError = (error) => {
    return { hasError: true, error };
  };

  componentDidCatch = () => {
    const { history } = this.props;

    history.listen(() => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
        });
      }
    });
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;
    return hasError ? <ErrorPage isFrontError error={error} /> : children;
  }
}

export default withRouter(ErrorBoundary);
